import React from 'react';
import Modal from 'components/UI/Modal';
import CloseButton from 'components/UI/CloseButton';
import LazyImage from 'components/UI/LazyImage';
import Title from 'components/UI/Title';
import Link from 'components/UI/Link';
import { useTrans } from 'utils/localisation';
import * as styles from './CertificateModal.module.scss';

export default function CertificateModal({ img, title, description, link, linkTitle, ...props }) {
  const t = useTrans(['common']);
  return (
    <Modal closeButton={false} containerMod="small" contentMod="paddingXXL" {...props}>
      {onClose => (
        <>
          <CloseButton onClose={onClose} />
          <figure className={styles.figure}>
            <LazyImage className={styles.img} src={img} alt={title} />
            <figcaption className={styles.figcaption}>
              <Title size="h4" tag="p">
                {title}
              </Title>
              <p className={styles.description}>{description}</p>
              {link && (
                <Link className={styles.link} href={link} onClick={onClose}>
                  {linkTitle ?? t('seeMore')}
                </Link>
              )}
            </figcaption>
          </figure>
        </>
      )}
    </Modal>
  );
}
